// src/pages/ProfilePage.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';
import { Alert, Spinner, PageHeader, LoadingScreen } from '../components/ui';

export default function ProfilePage() {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [form, setForm]   = useState({ dob: '', time_of_birth: '', place_of_birth: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [msg, setMsg]         = useState({ type: '', text: '' });

  useEffect(() => {
    api.get('/user/profile.php').then(({ data }) => {
      setProfile(data.profile);
      setForm({ dob: data.profile.dob || '', time_of_birth: data.profile.time_of_birth || '', place_of_birth: data.profile.place_of_birth || '' });
    }).finally(() => setLoading(false));
  }, []);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const handleSubmit = async e => {
    e.preventDefault(); setMsg({ type: '', text: '' }); setSaving(true);
    try { await api.post('/user/profile.php', form); setMsg({ type: 'success', text: 'Birth details updated!' }); }
    catch (err) { setMsg({ type: 'error', text: err.response?.data?.message || 'Update failed' }); }
    finally { setSaving(false); }
  };

  if (loading) return <LoadingScreen />;
  return (
    <div className="max-w-2xl mx-auto">
      <PageHeader icon="👤" title="My Profile" subtitle="Manage your account and birth details" />
      <div className="cosmic-card p-6 mb-6">
        <h2 className="font-cinzel font-semibold text-white mb-4">Account Information</h2>
        <div className="flex items-center gap-4 mb-4">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-cosmic-500 to-purple-700 flex items-center justify-center text-white font-bold text-2xl">
            {user?.name?.[0]?.toUpperCase()}
          </div>
          <div>
            <p className="font-semibold text-white text-lg">{user?.name}</p>
            <p className="text-cosmic-400">{user?.email}</p>
            <span className={"badge mt-1 " + (user?.role === 'admin' ? 'bg-yellow-500/20 text-yellow-300 border-yellow-500/30' : 'bg-cosmic-700/40 text-cosmic-300 border-cosmic-600/30')}>
              {user?.role === 'admin' ? '⚙️ Admin' : '🌟 Member'}
            </span>
          </div>
        </div>
      </div>
      <div className="cosmic-card p-6">
        <h2 className="font-cinzel font-semibold text-white mb-2">Birth Details</h2>
        <p className="text-cosmic-400 text-sm mb-6">Used for Kundli and Horoscope readings.</p>
        {msg.text && <div className="mb-5"><Alert type={msg.type}>{msg.text}</Alert></div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div><label className="cosmic-label">Date of Birth</label>
            <input name="dob" type="date" required className="cosmic-input" value={form.dob} onChange={handleChange} /></div>
          <div><label className="cosmic-label">Time of Birth</label>
            <input name="time_of_birth" type="time" required className="cosmic-input" value={form.time_of_birth} onChange={handleChange} /></div>
          <div><label className="cosmic-label">Place of Birth</label>
            <input name="place_of_birth" required className="cosmic-input" placeholder="e.g. New Delhi, India" value={form.place_of_birth} onChange={handleChange} /></div>
          <button type="submit" disabled={saving} className="btn-cosmic">
            {saving ? <span><Spinner size="sm" /> Saving...</span> : '💾 Save Birth Details'}
          </button>
        </form>
      </div>
    </div>
  );
}
